import React from "react";
import { buildRoutes } from "@app/routes/RouteBuilder";
import lazyWithRetry from "@shared/utils/lazyWithRetry";

// Lazy loading con retry automático
const GestionPendientesSupervisor = lazyWithRetry(
  () => import("./ui/GestionPendientes/GestionPendientesSupervisor"),
  "GestionPendientesSupervisor",
);

/**
 * Rutas de monitoreo
 */
const monitoringRoutes = buildRoutes([
  {
    path: "/monitor",
    element: GestionPendientesSupervisor,
    roles: [3, 5],
  },
]);

export default monitoringRoutes;
